'use client';

import React from 'react';
import ArticlesManagement from './components/ArticlesManagement';


export default function ArticlesPage() {
  return (

    <ArticlesManagement />

  );
}
